
import Vue from "vue";

export default Vue.extend({
  name: "component-place-category-icon",
  props: {
    iconName: String,
  },
  data: () => ({
    iconUri: process.env.VUE_APP_GENRE_ICON_URL ?? "",
  }),
});
